/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIPromptFromJSON, ApiAIPromptToJSON, } from './ApiAIPrompt';
export function ApiListAISessionsPromptsResponseFromJSON(json) {
    return ApiListAISessionsPromptsResponseFromJSONTyped(json, false);
}
export function ApiListAISessionsPromptsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prompts': !exists(json, 'prompts') ? undefined : (json['prompts'].map(ApiAIPromptFromJSON)),
    };
}
export function ApiListAISessionsPromptsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prompts': value.prompts === undefined ? undefined : (value.prompts.map(ApiAIPromptToJSON)),
    };
}
